<template>
  <section class="main">
    <img :src="imageUrl+'?'+suffix" alt="">
  </section>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      imageUrl: 'http://edubot-1252617679.picsh.myqcloud.com/img_2.jpg',
      suffix: new Date().getTime()
    }
  },
  created() {

  },
  computed: {

  },
  methods: {

  }
}

</script>
<style lang="scss" scoped>
.main {
  width: 100%;
  img {
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// ActivityNewBookMonth11.vue?623a476a